import { SelectionModel } from '@angular/cdk/collections';

/**
 * Selección con checkbox de una lista (tabla y tarjetas comparten la misma).
 * Compara por `id`, así que sirve aunque la tabla y las tarjetas usen copias.
 */
export class ListSelection<T = any> {
  readonly model = new SelectionModel<T>(true, [], true, (a: any, b: any) => a?.id != null && a.id === b?.id);

  /** `rows` = lo visible (filtrado): el checkbox del encabezado marca eso. */
  constructor(private readonly rows: () => T[]) {}

  get selected(): T[] { return this.model.selected; }
  get count(): number { return this.model.selected.length; }
  isSelected(row: T): boolean { return this.model.isSelected(row); }
  toggle(row: T): void { this.model.toggle(row); }
  clear(): void { this.model.clear(); }

  allSelected(): boolean {
    const rows = this.rows() ?? [];
    return rows.length > 0 && rows.every(r => this.model.isSelected(r));
  }
  someSelected(): boolean { return this.model.hasValue() && !this.allSelected(); }
  toggleAll(): void {
    const rows = this.rows() ?? [];
    if (this.allSelected()) this.model.deselect(...rows);
    else this.model.select(...rows);
  }
}

/** Vista de la lista (tabla / tarjetas), recordada por pantalla. */
export class ListView {
  private _mode: 'table' | 'cards';
  constructor(private readonly key: string, fallback: 'table' | 'cards' = 'table') {
    let saved: string | null = null;
    try { saved = localStorage.getItem(`listViewMode:${key}`); } catch { /* sin almacenamiento */ }
    this._mode = saved === 'cards' || saved === 'table' ? saved : fallback;
  }
  get mode(): 'table' | 'cards' { return this._mode; }
  set(mode: 'table' | 'cards'): void {
    if (mode !== 'table' && mode !== 'cards') return;
    this._mode = mode;
    try { localStorage.setItem(`listViewMode:${this.key}`, mode); } catch { /* no crítico */ }
  }
}
